export function loadImageElement(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();

    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error(`Failed to load image: ${url}`));
    image.src = url;
  });
}

export function extractImageIntensity(imageElement) {
  const width = imageElement.naturalWidth || imageElement.width;
  const height = imageElement.naturalHeight || imageElement.height;

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;

  const context = canvas.getContext("2d", {
    willReadFrequently: true,
  });

  if (!context) {
    throw new Error("Unable to create 2D canvas context.");
  }

  context.drawImage(imageElement, 0, 0);

  const imageData = context.getImageData(0, 0, width, height);

  return {
    width,
    height,
    data: imageData.data,
  };
}

export function sampleImageIntensity(imageData, point) {
  if (!imageData || !point) {
    return 1;
  }

  const x = Math.max(0, Math.min(imageData.width - 1, Math.round(point.x)));
  const y = Math.max(0, Math.min(imageData.height - 1, Math.round(point.y)));
  const index = (y * imageData.width + x) * 4;

  const r = imageData.data[index];
  const g = imageData.data[index + 1];
  const b = imageData.data[index + 2];

  return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
}
